import { apiClient } from '../../services/api';
import log from 'loglevel'

import {
    SET_DEVICES,
    UPDATE_DEVICE,
    ACTIVATE_DEVICE,
    GET_SYSTEM,
  } from './reducer';
import { DEAUTHENTICATE_USER } from '../../Authentication/reducer';

function set_devices (devices) {
  return { type: SET_DEVICES, devices };
}

function update_device (deviceId, device) {
  return { type: UPDATE_DEVICE, deviceId, device };
}

function get_system(deviceId){
    return {type: GET_SYSTEM, deviceId}
}

// export function activateDevice (id) {
//   return { type: ACTIVATE_DEVICE, id };
// }

/**
 * fetchDevices
 * @return {Array} of Entries
 */
export function fetchDevices(callback) {
    return dispatch =>
      // apiClient.get('devices?access_token='+accessToken)
      apiClient.get('devices/')
        .then((response) => {
          if (response.status === 200) {
              log.debug("FETCHDEV!!!!!:", response.data)
              if(callback) callback(response.data);
            return dispatch(set_devices(response.data));
          }
          return dispatch(hasError(response.status, response.statusText));
        })
        .catch((e) => {
          dispatch(hasError(e.message, e));
          //console.log(e)
        });
  }

/**
* loadSystem
* @return {Array} of Entries
*/
export function loadSystem(deviceOfInterest) {
    log.debug("IM IN THE SYSTEM LOAD!!!!, DEVICE ID: ", deviceOfInterest)
    var data = { deviceid: deviceOfInterest }
    return dispatch =>
        apiClient.post('control/settings/store', data)
            .then(res => {
                log.debug("SYSTEMLOAD, in POST... Response Data:", res.data)
                if (res.status === 200) {

                    apiClient.get(`control/settings/${deviceOfInterest}`)
                        .then((response) => {
                            if (response.status === 200) {
                                log.debug("SYSTEMLOAD!!!!!:", response.data)
                                return dispatch(get_system(deviceOfInterest));
                            }
                            return dispatch(hasError(response.status, response.statusText));
                        })
                        .catch((e) => {
                            dispatch(hasError(e.message, e));
                        });
                }
            })
            .catch((e) => {
                dispatch(hasError(e.message, e));
            });

}


  /**
 * updateDevice
 * @return {Array} of Entries
 */
export function updateDevice(accessToken, id, label) {
      var device = {label: label};
      log.debug("updateDevice", id, device)
    return dispatch =>
      apiClient.put('devices/'+id, device)
        .then((response) => {
          if (response.status === 200) {
              dispatch(fetchDevices())
            return response.json();
          }
          return dispatch(hasError(response.status, response.statusText));
        })
        .then((json) => {
          if (json.type && json.type === 'ERROR') {
            return dispatch(hasError(json.param, json.message));
          }
          log.debug(json)
            dispatch(fetchDevices())
          return dispatch(update_device(json));
        })
        .catch((e) => {
          dispatch(hasError(e.message, e));
        });
  }

  /**
 * createDevice
 * @return {Array} of Entries
 */
export function createDevice(device, successCB, errorCB) {
    return (dispatch) => {
        apiClient.post('assignment', device)
            .then((response) => {
                log.debug("response", response);
                if (response.status === 200) {
                    log.debug("SUCCESS", successCB)
                    if(successCB) successCB();
                    return response.json();
                }
                if(errorCB) errorCB(response);
                return dispatch(hasError(response.status, response.statusText));
            })
            .then((json) => {
                if (json.type && json.type === 'ERROR') {
                    return dispatch(hasError(json.param, json.message));
                }
                log.debug(json)
                log.debug("SUCCESS", successCB)
                if(successCB) successCB();
                return dispatch(update_device(json));
            })
            .catch((e) => {
                if(errorCB) errorCB(e.response);
                dispatch(hasError(e.message, e));
            }).finally(() => {
        });
    }

  }

export function deleteDevice(deviceid, successCB) {
    log.debug("deleteDevice", deviceid)

    return (dispatch) => {
        apiClient.post('assignment/delete', deviceid)
            .then((response) => {
                if (response.status === 200) {
                    log.debug("deleteDevice", response.status)
                    if(successCB) successCB();
                    dispatch(set_devices())
                    //TODO(Hoffmannm): FIXME: next line never executed, what should happen?
                    return response.json();
                }
                return dispatch(hasError(response.status, response.statusText));
            })
            .then((json) => {
                if (json.type && json.type === 'ERROR') {
                    return dispatch(hasError(json.param, json.message));
                }
                log.debug(json)
                log.debug("deleteDevice SUCCESS", deviceid)
                if(successCB) successCB();
                return dispatch(update_device(json));
            })
            .catch((e) => {
                dispatch(hasError(e.message, e));
            }).finally(() => {
                log.debug("deleteDevice SUCCESS", deviceid)
            if(successCB) successCB();
        });
    }

}
export function deleteAssignment(data, successCB) {
    log.debug("deleteAssignment", data)

    return (dispatch) => {
        apiClient.post('assignment/deleteAssignment', data)
            .then((response) => {

            })
            .catch((e) => {
                dispatch(hasError(e.message, e));
            }).finally(() => {
            if(successCB) successCB();
        });
    }

}


export function updateScopeLabel(deviceid, label) {
    var data  = {deviceid: deviceid, label: label};
    return dispatch =>
        apiClient.post('control/label', data)
            .then((response) => {
                if (response.ok === true) {
                    return response.json();
                }
                return dispatch(hasError(response.status, response.statusText));
            })
            .then((json) => {
                if (json.type && json.type === 'ERROR') {
                    return dispatch(hasError(json.param, json.message));
                }
                log.debug(json)
                return dispatch(update_device(json));
            })
            .catch((e) => {
                dispatch(hasError(e.message, e));
            });
}

  /**
   * hasError
   * @param {string}   cause
   * @param {Object}  exception
   * @return {Action}   action
   */
function hasError(param, message) {
    // log.debug(param)
    if (param === "Request failed with status code 401") {
        return {type: DEAUTHENTICATE_USER}
    }
    // log.debug(param);
    // log.debug(param, message);
    return { type: 'ERROR', param, message };
}


export function setFanVal(deviceid, zone, fanVal) {
      var data = {deviceid: deviceid, zone:zone, value: fanVal}
    return dispatch =>
        apiClient.post('control/fanlevel', data)
            .then((response) => {
                if (response.ok === true) {
                    return response.json();
                }
                return dispatch(hasError(response.status, response.statusText));
            })
            .then((json) => {
                if (json.type && json.type === 'ERROR') {
                    return dispatch(hasError(json.param, json.message));
                }
                log.debug(json)
                return dispatch(update_device(json));
            })
            .catch((e) => {
                dispatch(hasError(e.message, e));
            });
}

export function activateDevice(deviceid) {
    var data = {deviceid: deviceid}
    return dispatch =>
        apiClient.post('users/activateDevice', data)
            .then((response) => {
                dispatch({ type: ACTIVATE_DEVICE, id: deviceid })
            })
            .then((json) => {
                // onMyload()
            })
            .catch((e) => {
                log.error("activate Device catch", e)
            });
}
